import styled from "styled-components";

const RowImagesContainer = styled.div`
  display: flex;
`;
export default RowImagesContainer;
